import { render } from "./NutritionFacts.vue?vue&type=template&id=62b41c1c&scoped=true"
import script from "./NutritionFacts.vue?vue&type=script&setup=true&lang=js"
export * from "./NutritionFacts.vue?vue&type=script&setup=true&lang=js"

import "./NutritionFacts.vue?vue&type=style&index=0&id=62b41c1c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b41c1c"],['__file',"resources/js/modules/product-submission/components/filter/NutritionFacts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62b41c1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62b41c1c', __exports__)) {
    api.reload('62b41c1c', __exports__)
  }
  
  module.hot.accept("./NutritionFacts.vue?vue&type=template&id=62b41c1c&scoped=true", () => {
    api.rerender('62b41c1c', render)
  })

}


export default __exports__